//用于储存不可变常量
let constantdata={
    companytype:[
        {
            type:0,
            value:"酒店式"
        },
        {
            type:1,
            value:"公寓式"
        }
    ],
    privilegetype:[
        {
            type:0,
            value:"页面级权限"
        },
        {
            type:1,
            value:"按钮级权限"
        }
    ]


}
export default constantdata;


// WEBPACK FOOTER //
// ./src/constant/index.js